
import React from 'react';

const BackorderNotAvailable = (props) => {
    const { SetStatus } = props

    return (
        <>
            <div className="avnet-modal modal-680">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close" data-dismiss="modal"
                        onClick={() => { SetStatus(false) }}>×
                    </button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="pcn-modal-heading">Your Order</h3>
                    </div>
                    <div className="modal-body">
                        <p><center>This part is not allowed for Backorder.</center></p>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer justify-content-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-primary btn-sm w145"
                                data-bs-toggle="modal" data-bs-target="#InventoryModal"
                                onClick={() => { SetStatus(false) }}>
                                CLOSE
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default BackorderNotAvailable;